module.exports = __webpack_public_path__ + "static/media/inspire-2.21280a05.mp3";